import socket from './socket';

const updatePointSystem = (boardId, data, headers) =>
  socket.patch(`/boards/${boardId}/point-system`, data, headers);

export default {
  updatePointSystem,
};

